import { React, useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Checkbox,
    ListItemText,
    Grid,
    Typography, CardContent,
    Link,
    Box,
    Tabs,
    Tab,
    Badge,
    FormLabel,
    Modal,
    Chip,
    TextareaAutosize,
    Menu,
    ListItemIcon,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth, format, parse } from 'date-fns';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SubdirectoryArrowRightOutlinedIcon from "@mui/icons-material/SubdirectoryArrowRightOutlined";
import AddIcon from '@mui/icons-material/Add';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../../components/Page';
import { handleError } from '../../../components/Common/Utils';
import Blog from '../../../pages/Blog'
import ApplyForLeave from '../../../components/SidebarMenuComponents/LeaveComponent/ApplyForLeave';
import LeaveHistory from '../../../components/SidebarMenuComponents/LeaveComponent/LeaveHistory';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '92%',
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
// --- Custom Styled Components ---

const StyledTabs = styled(Tabs)({
    minHeight: '35px',
    '& .MuiTabs-indicator': {
        display: 'none', // Hide default indicator
    },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    marginRight: theme.spacing(0.5),
    padding: '8px 20px',
    minHeight: '35px',
    color: '#7B7B7B',
    borderRadius: '8px 8px 0px 0px',
    border: '1px solid transparent', // Maintain layout stability
    '&.Mui-selected': {
        color: '#000',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderTop: '1px solid #e8e8e8',
        borderLeft: '1px solid #e8e8e8',
        borderRight: '1px solid #e8e8e8',
        borderBottom: '1px solid #fff', // This "cuts" the main box border
        marginBottom: '-1px', // Overlaps the border below
        zIndex: 1,
    },
}));

const tmpCache = {};

const stripHtml = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
};
export default function LeaveDetailsPage() {
    const location = useLocation();
    const { onOpenSidebar, open, onCloseSidebar } = useOutletContext();
    const [isLoading, setIsLoading] = useState();
    const [value, setValue] = useState(0);

    // Apply for leave
    const pastLeaveColumns = [
        {
            field: 'date',
            headerName: 'Date',
            flex: 0.5,
        },
        {
            field: 'leaveDetails',
            headerName: 'Leave Details',
            flex: 0.5,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.5,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    size="small"
                    sx={{
                        backgroundColor: '#E5F5EB',
                        color: '#00A63E',
                        fontWeight: 500,
                        fontSize: '12px',
                        borderRadius: '6px'
                    }}
                />
            )
        }
    ];

    const upcomingLeaveColumns = [
        {
            field: 'date',
            headerName: 'Date',
            flex: 0.5,
        },
        {
            field: 'leaveDetails',
            headerName: 'Leave Details',
            flex: 0.5,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.5,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    size="small"
                    sx={{
                        backgroundColor: '#FEF9C2',
                        color: '#894B00',
                        fontWeight: 500,
                        fontSize: '12px',
                        borderRadius: '6px'
                    }}
                />
            )
        }
    ];

    const teamImpactColumns = [
        {
            field: 'executiveName',
            headerName: 'Executive Name',
            flex: 0.5,
        },

        {
            field: 'status',
            headerName: 'Status',
            flex: 0.5,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    size="small"
                    sx={{
                        backgroundColor: '#E5F5EB',
                        color: '#00A63E',
                        fontWeight: 500,
                        fontSize: '12px',
                        borderRadius: '6px'
                    }}
                />
            )
        }
    ];
    // leave history
    const historyColumns = [
        { field: 'leaveType', headerName: 'Leave Type', flex: 1 },
        { field: 'appliedDate', headerName: 'Applied Date', flex: 1 },
        { field: 'remark', headerName: 'Remark', flex: 1.5 },
        { field: 'dates', headerName: 'Dates', flex: 1.5 },
        { field: 'totalDays', headerName: 'Total Days', flex: 0.8, align: 'center' },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                let color
                let bgColor

                if (status === 'Approved') { color = '#00A63E'; bgColor = '#E5F5EB'; }
                if (status === 'Pending') { color = '#894B00'; bgColor = '#FEF9C2'; }
                if (status === 'Rejected') { color = '#D93A46'; bgColor = '#FAE3E6'; }

                return (
                    <Chip
                        label={status}
                        size="small"
                        sx={{ color: color, bgcolor: bgColor, fontWeight: 500, fontSize: 12 }}
                    />
                );
            }
        },
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            flex: 0.5,
            headerAlign: 'right',
            align: 'right',
            renderCell: (cellValues) => (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        pr: 0.5,
                        boxShadow: 'none',

                    }}
                >

                    <IconButton size="small" onClick={(event) => handleMenuOpen(event, cellValues.row)}>
                        <MoreVertIcon sx={{ fontSize: 18, color: "#444" }} />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                boxShadow: 'none',
                                border: '1px solid #D1D5DB'
                            }
                        }}
                        MenuListProps={{
                            sx: {
                                width: 113,
                                py: 0,

                                '& .MuiMenuItem-root': {
                                    px: 1.5,

                                },
                                '& .MuiMenuItem-root .MuiListItemIcon-root': {
                                    minWidth: '0 !important',
                                },
                                '& .MuiMenuItem-root:hover': {
                                    backgroundColor: "#FFF2F0",
                                },
                            },
                        }}
                    >
                        <MenuItem onClick={() => { handleViewLeaveHistoryOpenModal(selectedRow) }}>
                            <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                <Icon icon="mdi:eye-outline" width={14} height={14} style={{ color: "#3866E3" }} />
                            </ListItemIcon>
                            <ListItemText primary="View" />
                        </MenuItem>

                        <MenuItem onClick={() => handleEditLeave(cellValues.row)}>
                            <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                <Icon icon="material-symbols:border-color-outline" width={14} height={14} style={{ color: "#0086FF" }} />

                            </ListItemIcon>
                            <ListItemText primary="Edit" />
                        </MenuItem>

                        <MenuItem onClick={() => { handleOpenCancelModal(cellValues.row) }}
                        >
                            <ListItemIcon sx={{ minWidth: 0, mr: 1 }}  >
                                <Icon icon="material-symbols:cancel-outline" width={14} height={14} style={{ color: "#E10F00" }} />

                            </ListItemIcon>
                            <ListItemText primary="Cancel" />
                        </MenuItem>
                    </Menu>

                </Box>
            )
        }

    ];

    const historyRows = [
        {
            id: 1,
            leaveType: 'Leave',
            appliedDate: '01-Sept-2025',
            remark: 'Not feeling well. Had cough and cold',
            dates: '02-Sept-2025',
            totalDays: '01',
            status: 'Pending'
        },
        {
            id: 2,
            leaveType: 'Leave',
            appliedDate: '20-Aug-2025',
            remark: 'Ganapati leaves',
            dates: '23-Aug-2025 ; 24-Aug-2025 ; 25-Aug-2025',
            totalDays: '03',
            status: 'Approved'
        },
        {
            id: 3,
            leaveType: 'Post-HD',
            appliedDate: '11-Aug-2025',
            remark: 'Ganapati leaves',
            dates: '26-Aug-2025',
            totalDays: '01',
            status: 'Rejected'
        }
    ];

    // Apply for leave
    const [date, setDate] = useState([]);
    const [remark, setRemark] = useState("");
    const [pageSize, setPageSize] = useState(25);
    const [pageSize1, setPageSize1] = useState(25);
    const [leaveTypeRadio, setLeaveTypeRadio] = useState({});


    //Leave history
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [leaveType, setLeaveType] = useState("");
    const [selectedLeaveType, setSelectedLeaveType] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const openMenu = Boolean(anchorEl);
    const [viewLeaveHistoryModal, setViewLeaveHistoryModal] = useState(false);
    const [viewLeaveHistoryData, setViewLeaveHistoryData] = useState([]);
    const [cancelModal, setCancelModal] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editModalData, setEditModalData] = useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // Apply for leave
    const handleDate = (newDate) => {
        if (!newDate) return;

        const formatted = format(newDate, "dd-MMM-yyyy");

        setDate((prev) =>
            prev.some((d) => format(d, "dd-MMM-yyyy") === formatted)
                ? prev.filter((d) => format(d, "dd-MMM-yyyy") !== formatted)
                : [...prev, newDate]
        );
    };
    const selectedImpactDate = date.length > 0 ? format(date[date.length - 1], "dd-MM-yyyy") : "";

    const handleRemark = (event) => {
        setRemark(event.target.value)
    };
    const handleApplyForLeave = () => {
    };
    const handleLeaveTypeRadio = (event, selectedDate) => {
        const value = event.target.value;

        setLeaveTypeRadio((prev) => ({
            ...prev,
            [format(selectedDate, "dd-MMM-yyyy")]: value,
        }));
    };
    const handleDeleteDate = (indexToRemove) => {
        setDate((prev) => prev.filter((_, i) => i !== indexToRemove));

        // optional: also remove that date’s radio selection
        setLeaveTypeRadio((prev) => {
            const updated = { ...prev };
            const removedDate = format(date[indexToRemove], "dd-MMM-yyyy");
            delete updated[removedDate];
            return updated;
        });
    };
    //Leave History Type
    const handleFromDate = (newValue) => {
        setFromDate(newValue);
    };
    const handleToDate = (newValue) => {
        setToDate(newValue);
    };
    const handleLeaveType = (event, newValue) => {
        setLeaveType(newValue);
    };
    const handleFilterLeaveHistory = () => {

    };
    const handleLeaveHistoryReset = () => {
        setFromDate(null);
        setToDate(null);
        setLeaveType("");
        setViewLeaveHistoryData([]);
    };
    const handleMenuOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleViewLeaveHistoryCloseModal = () => {
        setViewLeaveHistoryModal(false);

    };
    const handleViewLeaveHistoryOpenModal = (cellValues) => {
        console.log("cellValues", cellValues)
        setViewLeaveHistoryModal(true);
        setViewLeaveHistoryData(cellValues);
        setAnchorEl(null);

    };
    const handleCancel = (cellValues) => {
        setIsLoading(true);

        const payload = {
            IssueId: Number(selectedIssueId) || 0,
            UserId: userId || 0,
        };

        URLS.deleteRoutineIssue(payload)
            .then((response) => {
                if (response.status === 200) {
                    URLS.filterRoutineIssueId(0)
                        .then((response) => {
                            if (Array.isArray(response.data) && response.data[0]?.Error) {
                                setEditData([]);

                            } else {
                                setEditData(response.data);
                                handleCancel();
                                enqueueSnackbar("Routine Issue deleted successfully.", {
                                    variant: "success",
                                });
                            }
                            setIsLoading(false); // stop loader after refresh completes
                        })
                        .catch((error) => {
                            console.error("Refresh Error:", error);
                            setEditData([]);

                            setIsLoading(false);
                        });
                }
                // else {
                //    enqueueSnackbar("Failed to delete Routine Issue ID.", { variant: "error" });
                //    setIsLoading(false);
                // }
            })
            .catch((error) => {
                console.error("Delete Error:", error);
                enqueueSnackbar("Failed to delete Routine Issue.", { variant: "error" });

                setIsLoading(false);
            });
    };

    const handleCancelConfirm = () => {
        if (selectedRow) {
            handleCancel(selectedRow); // pass row
        }
        setCancelModal(false);
    };
    const handleCancelClick = () => {
        setCancelModal(false);
    };
    const handleOpenCancelModal = (row) => {
        setSelectedRow(row);
        setCancelModal(true);
    };
    const handleEditLeave = (row) => {
        setEditModalData({
            dates: row.dates.split(' ; ').map(d => parse(d, 'dd-MMM-yyyy', new Date())),
            remark: row.remark,
        });
        setEditModalOpen(true);
    };
    const handleEditOpenModal = () => {
        setEditModalOpen(true);
    };
    const handleEditCloseModal = () => {
        setEditModalOpen(false);
    };
    const handleEditDate = (newDate) => {
        if (!newDate) return;

        setEditModalData((prev) => ({
            ...prev,
            dates: [newDate], // only one date
        }));
    };
    const handleEditRemark = (event) => {
        setEditModalData((prev) => ({
            ...prev,
            remark: event.target.value,
        }));
    };
    const handleUpdateLeave = () => {
        console.log("Updated leave data", editModalData);

        // call update API here

        setEditModalOpen(false);
    };
    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    }, []);

    return (
        <>
            <Page title="Leave Management | tiketic">
                <Grid container spacing={2}>
                    {/* LEFT COLUMN: Tabs and Content */}
                    <Grid item xs={12} md={value === 1 ? 9.5 : 12}>
                        {/* 1. The Tab Header Area */}
                        <Box>
                            <StyledTabs value={value} onChange={handleChange}>
                                <StyledTab label="Apply For Leave" />
                                <StyledTab label="Leave History" />
                                <StyledTab label="My Team" />
                                <StyledTab label="Attendance Report" />
                            </StyledTabs>
                        </Box>

                        {/* 2. The Main Content Box */}
                        <Box
                            sx={{
                                bgcolor: '#fff',
                                borderRadius: '0 8px 8px 8px', // Top-left is sharp if first tab is active
                                border: '1px solid #e8e8e8',
                                minHeight: '420px',      // Enforces exactly 420px height
                                overflowY: 'auto',
                                width: '100%',     // Uniform width
                                boxShadow: 'none',
                                position: 'relative',
                                mt: '-1px', // Aligns with the Tab's bottom border trick
                            }}
                        >
                            {/* Tab Panels */}
                            {value === 0 &&
                                <ApplyForLeave date={date} handleDate={handleDate} remark={remark} handleRemark={handleRemark} handleApplyForLeave={handleApplyForLeave} pastLeaveColumns={pastLeaveColumns} upcomingLeaveColumns={upcomingLeaveColumns} pageSize={pageSize} setPageSize={setPageSize} pageSize1={pageSize1} setPageSize1={setPageSize1} handleLeaveTypeRadio={handleLeaveTypeRadio} leaveTypeRadio={leaveTypeRadio} handleDeleteDate={handleDeleteDate} teamImpactColumns={teamImpactColumns} selectedImpactDate={selectedImpactDate} />
                            }

                            {value === 1 &&
                                <LeaveHistory fromDate={fromDate} handleFromDate={handleFromDate} toDate={toDate} handleToDate={handleToDate} leaveType={leaveType} selectedLeaveType={selectedLeaveType} handleLeaveType={handleLeaveType} handleFilterLeaveHistory={handleFilterLeaveHistory} handleLeaveHistoryReset={handleLeaveHistoryReset} anchorEl={anchorEl} handleMenuOpen={handleMenuOpen} handleMenuClose={handleMenuClose} openMenu={openMenu} viewLeaveHistoryModal={viewLeaveHistoryModal} handleViewLeaveHistoryCloseModal={handleViewLeaveHistoryCloseModal} handleViewLeaveHistoryOpenModal={handleViewLeaveHistoryOpenModal} historyColumns={historyColumns} historyRows={historyRows} viewLeaveHistoryData={viewLeaveHistoryData} cancelModal={cancelModal} handleCancelConfirm={handleCancelConfirm} handleCancel={handleCancel} handleCancelClick={handleCancelClick} editModalOpen={editModalOpen} setEditModalOpen={setEditModalOpen} setEditModalData={setEditModalData} editModalData={editModalData} pastLeaveColumns={pastLeaveColumns} upcomingLeaveColumns={upcomingLeaveColumns} handleLeaveTypeRadio={handleLeaveTypeRadio} leaveTypeRadio={leaveTypeRadio} handleDeleteDate={handleDeleteDate} teamImpactColumns={teamImpactColumns} selectedImpactDate={selectedImpactDate} date={date} handleDate={handleDate} remark={remark} handleRemark={handleRemark} handleApplyForLeave={handleApplyForLeave}

                                    handleEditDate={handleEditDate} handleEditRemark={handleEditRemark} handleUpdateLeave={handleUpdateLeave} handleEditOpenModal={handleEditOpenModal} handleEditCloseModal={handleEditCloseModal}
                                />
                            }

                            {value === 2 && <Box sx={{ typography: 'body1' }}>My Team Content</Box>}
                            {value === 3 && <Box sx={{ typography: 'body1' }}>Attendance Report Content</Box>}
                        </Box>

                    </Grid>
                    {value === 1 && (
                        <Grid item xs={12} md={2.5}>
                            <Stack spacing={2}>
                                <Typography variant="h6">Leave Balance</Typography>

                                {/* Status Cards */}
                                <Card variant="outlined" sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Icon icon="solar:Check-circle-bold" color="green" width="24" />
                                        <Typography variant="body2">Leaves</Typography>
                                    </Stack>
                                    <Chip label="2" size="small" variant="outlined" />
                                </Card>

                                <Card variant="outlined" sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Icon icon="solar:close-circle-bold" color="red" width="24" />
                                        <Typography variant="body2">Absent</Typography>
                                    </Stack>
                                    <Chip label="1" size="small" variant="outlined" />
                                </Card>

                                {/* Pie Chart Card */}
                                <Card variant="outlined" sx={{ p: 2 }}>
                                    {/* Insert your Chart component here */}
                                    <Typography variant="subtitle2" gutterBottom>Attendance Summary</Typography>
                                    <Box sx={{ height: 200, bgcolor: '#f9f9f9', borderRadius: 1 }} />
                                </Card>
                            </Stack>
                        </Grid>
                    )}
                </Grid>
                {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
            </Page>
        </>

    );
}